import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LinkConfig } from '@zipari/shared-ds-util-navigation';
import { ButtonLevels, ButtonSizes } from '@zipari/shared-ds-util-button';
import {
  ActionButtonConfig,
  ActionButtonMetaConfig,
  ActionItemConfig,
} from './action-button.constants';
import { ExternalSiteModalConfig } from '../../chords/external-site-warning-modal/external-site-warning-modal.model';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'action-button',
  templateUrl: './action-button.component.html',
  styleUrls: ['./action-button.component.scss'],
})
export class ActionButtonComponent implements OnInit {
  @Input() actionButtonMetaConfig: ActionButtonMetaConfig;
  @Input() externalSiteModalConfig: ExternalSiteModalConfig;
  @Input() isDisabled = false;
  @Output() actionButtonClicked = new EventEmitter();
  @Output() actionLinkClicked: EventEmitter<LinkConfig> = new EventEmitter();
  actionButtonConfig: ActionButtonConfig;
  actionsConfig: ActionItemConfig[];

  showSubnav = false;
  buttonLevels = ButtonLevels;
  buttonSizes = ButtonSizes;
  get iconFill() {
    return `btn-${this.actionButtonConfig?.level}__icon--resting`;
  }

  ngOnInit() {
    const [actionButtonMetaConfig] = checkInputsForText([
      this.actionButtonMetaConfig,
    ]);

    this.actionButtonMetaConfig = actionButtonMetaConfig;

    if (!this.actionButtonMetaConfig.actionButton) {
      throw new Error('Missing config for actionButton');
    }
    if (!this.actionButtonMetaConfig.actions) {
      throw new Error('Missing config for actions');
    }

    this.actionButtonConfig = this.actionButtonMetaConfig.actionButton;
    this.actionsConfig = this.actionButtonMetaConfig.actions;
  }

  buttonClicked() {
    if (
      !this.isDisabled &&
      this.actionButtonMetaConfig.actionButton &&
      this.actionButtonMetaConfig.actions
    ) {
      this.showSubnav = !this.showSubnav;
    }
  }

  handleLinkClicked(link: LinkConfig) {
    this.actionLinkClicked.emit(link);
    this.showSubnav = false;
  }
}
